import type React from "react";
import { cn } from "src/shadcn/lib/utils";

import { Toggle as ShadcnToggle } from "src/shadcn/components/toggle";

const Toggle = ({
  className,
  ...props
}: React.ComponentProps<typeof ShadcnToggle>) => (
  <ShadcnToggle
    className={cn("cursor-pointer disabled:cursor-not-allowed", className)}
    {...props}
  />
);

export { Toggle };
export { toggleVariants } from "src/shadcn/components/toggle";
